/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'newMember': {
    width: 16,
    height: 16,
    viewBox: '0 0 108.38 86.88',
    data: '<defs/><path pid="0" class="cls-1" d="M39.42 41c9.4 1.51 8.09 1.2 17.3.06-3.39-7.37-.94-5.86 2.07-10.78C64.06 21.74 66.13-.39 48.45-.39c-16.55 0-17.12 19.67-10.72 31 2.45 4 5.45 4.35 1.88 10z"/><path pid="1" class="cls-1" d="M61.91 70.21a19.19 19.19 0 0 1 16.88-19.08C74.21 46.5 68 43.61 60.3 42l-7 25.71c-.94-1.89-3.95-12.48-3-14.37 0 0 1.07-1.95 1.12-2.13a6.7 6.7 0 0 0 .45-2.79l-3.27.48-3.2-.48c0 5.29 2.82 2.46.94 9.45a50.93 50.93 0 0 0-2.07 10.4C41.49 63 39 46 36.41 42.17 21 45.2 11.59 54.65 10.27 71.1 9.7 79 11.4 81.5 23.62 83.58c9.49 1.7 29.78 2.76 44.81 1.07a19.21 19.21 0 0 1-6.52-14.44z"/><path pid="2" class="cls-1" d="M80.27 54.19a15.75 15.75 0 1 0 15.66 15.74 15.7 15.7 0 0 0-15.66-15.74zM91.17 72h-9v9a1.79 1.79 0 1 1-3.59 0v-9h-8.95a1.8 1.8 0 0 1 0-3.59h9v-9a1.79 1.79 0 0 1 3.54 0v9h9a1.8 1.8 0 0 1 0 3.53z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/newMember.js